import router from 'Profile/js/router';
import store from 'Site/js/store';
import Vue from 'vue';
import VueRouter from 'vue-router';
import profileHeader from 'Profile/mixin/profileHeader';
import WallPost from 'Wall/component/Post.vue';

export default function () {
    Vue.use(VueRouter);

    new Vue({ /* eslint no-new: 0 */
        el: '#profile-vue',
        components: {
            WallPost
        },
        router,
        store,
        mixins: [profileHeader],
    });

    let settings = document.querySelector('#status-json').textContent;
    if (settings) {
        settings = JSON.parse(settings);
    }
}
